import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import PropagateLoader from "react-spinners/PropagateLoader";
import { useAPI } from "../../../../apiContext";

const About = () => {
	const { data } = useAPI();
	const [seeMore, setSeeMore] = useState(false);
	return (
		<Container sx={{ pt: 3 }}>
			{data?._id ? (
				<Box
					sx={{ border: "3px solid", borderRadius: "15px", p: 1 }}
					className='borderColor'>
					{!data?.headline?.aboutUs === "off" ? (
						""
					) : (
						<>
							<Typography
								className='textColor'
								sx={{ mb: 0.5, fontWeight: 900 }}
								variant='h4'
								component='div'
								gutterBottom>
								{data?.headline?.aboutUs}
								<Divider className={`${data?.color?.hr}`} />
							</Typography>
							<Grid container spacing={2}>
								<Grid
									item
									md={9}
									xs={12}
									className='textColor'
									sx={{ mx: "auto" }}>
									<Typography
										variant='h6'
										gutterBottom
										sx={{ whiteSpace: "pre-line" }}>
										{seeMore ? (
											<>
												{data?.details?.details}{" "}
												<span
													onClick={() => setSeeMore(false)}
													style={{
														fontWeight: "bold",
														textDecoration: "underline",
														cursor: "pointer",
													}}>
													See Less
												</span>
											</>
										) : (
											<>
												{data?.details?.details.slice(0, 300)}....
												<span
													onClick={() => setSeeMore(true)}
													style={{
														fontWeight: "bold",
														textDecoration: "underline",
														cursor: "pointer",
													}}>
													See More
												</span>
											</>
										)}
									</Typography>
								</Grid>
								<Grid item md={5} xs={7} sx={{ mx: "auto" }}>
									<img
										style={{ width: "100%" }}
										src={data?.details.imageLink2}
										alt=''
									/>
								</Grid>
							</Grid>
						</>
					)}
				</Box>
			) : (
				<div className='loader'>
					<PropagateLoader size={11} />
				</div>
			)}
		</Container>
	);
};

export default About;
